import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { ToastModule } from 'primeng/toast';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports : [
    IEssentialsModule,
    ToastModule
  ]
})
export class SharedModule { }
